<template>
    <v-select :items="invoiceYearItems" :value="value" @input="syncValue" label="Fakt. år" hide-details/>
</template>

<script>
import * as moment from "moment";

export default {
    props: {
        value: {
            type: Number
        },
    },
    methods: {
        syncValue(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        invoiceYearItems() {
            let year = moment().year();
            return [
                year, year - 1
            ].map(it => {
                return {value: it, text: '' + it};
            });
        },

    }
}
</script>

<style scoped>

</style>
